import React, { useState, useEffect } from 'react'
import classnames from 'classnames'

import { CoverageProtectionCheckBox } from './CoverageSurchargesFilterList'

const ProductOptionsFilterList = ({
  value,
  data,
  changeSelected,
  setName,
  subsectionId,
  initialOpen = false,
}) => {
  const [uiState, setUiState] = useState(initialOpen)

  useEffect(() => {
    if (initialOpen) {
      setUiState(true)
    }
  }, [initialOpen])

  const toggleUiState = () => setUiState(!uiState)

  const buttonClasses = classnames('refi-app__section-header__button', {
    'refi-app__section-header__button--open': uiState,
  })

  const sectionClass = classnames('', {
    'refi-app__section--open': uiState,
  })

  return (
    <div className={sectionClass}>
      <div
        className="refi-app__section-header"
        onClick={() => toggleUiState()}
        data-testid="coverage-sub-list-accordian"
      >
        <p className="coverage__sub-header coverage__sub-header--blue">
          {setName(value)}
        </p>
        <button className={buttonClasses}>Toggle</button>
        <hr className="form__hr" />
      </div>

      {uiState && (
        <div className="refi-payment-options__section">
          <div className="refi-payment-options__radio-buttons-group">
            {data && data.length > 0 && (
              <>
                {data.map((val) => (
                  <CoverageProtectionCheckBox
                    value={val}
                    changeSelected={() => changeSelected(val)}
                    selected={Array.isArray(value) && value.includes(val)}
                    key={val}
                    subsectionId={subsectionId}
                  />
                ))}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default ProductOptionsFilterList
